import { panelNavHtml } from '../panel-nav-html.js';

export interface BookingConfirmedPayload {
  reference: string;
  bookingUid: string;
  bookingStartUtc: string;
  callerTimezone: string;
  name: string;
  email: string;
  topic_summary: string;
  cancelUrl?: string;
  rescheduleUrl?: string;
  failed?: boolean;
}

export class BookingConfirmed {
  constructor(private readonly root: HTMLElement) {
    this.root.addEventListener('click', (e) => {
      const t = e.target as HTMLElement;
      if (t.closest('[data-action="close"]')) {
        this.hide();
        document.dispatchEvent(new CustomEvent('merlin:nav-close', { bubbles: true }));
        return;
      }
      if (t.closest('[data-action="back"]')) {
        document.dispatchEvent(new CustomEvent('merlin:nav-back', { bubbles: true }));
      }
    });
  }

  show(payload: BookingConfirmedPayload): void {
    this.root.innerHTML = this.render(payload);
    this.root.classList.add('visible');
  }

  hide(): void {
    this.root.classList.remove('visible');
  }

  private render(p: BookingConfirmedPayload): string {
    const start = new Date(p.bookingStartUtc);
    const localFmt = fmtFor(p.callerTimezone);
    const perthFmt = fmtFor('Australia/Perth');
    const local = localFmt.format(start);
    const perth = perthFmt.format(start);
    const isPerth = p.callerTimezone === 'Australia/Perth';
    const buttons = [
      p.rescheduleUrl ? `<a class="bc-btn" href="${esc(p.rescheduleUrl)}" target="_blank" rel="noopener">Reschedule</a>` : '',
      p.cancelUrl ? `<a class="bc-btn bc-btn--ghost" href="${esc(p.cancelUrl)}" target="_blank" rel="noopener">Cancel</a>` : '',
    ].filter(Boolean).join('');
    if (p.failed) {
      return `
        <div class="bc-card bc-card--error">
          ${panelNavHtml()}
          <h3>Booking pending</h3>
          <p>Cal.com was briefly unreachable — your details are saved and someone from the team will email you a link shortly.</p>
          <p class="bc-meta">Reference: <strong>${esc(p.reference)}</strong></p>
        </div>`;
    }
    return `
      <div class="bc-card">
        ${panelNavHtml()}
        <h3>Briefing booked</h3>
        <p class="bc-time">${esc(local)}${isPerth ? '' : ` <span class="bc-shadow">(${esc(perth)} Perth)</span>`}</p>
        <p class="bc-meta">Reference <strong>${esc(p.reference)}</strong> — confirmation on its way to <strong>${esc(p.email)}</strong>.</p>
        <div class="bc-actions">${buttons}</div>
      </div>`;
  }
}

function fmtFor(tz: string): Intl.DateTimeFormat {
  return new Intl.DateTimeFormat('en-AU', {
    timeZone: tz,
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
}

function esc(s: string): string {
  return s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]!));
}
